// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';

// Importar las páginas
import HomePage from './pages/HomePage';
import ProgramsPage from './pages/ProgramsPage';
import QuienesSomosPage from './pages/QuienesSomosPage';
import CollegesPage from './pages/CollegesPage';
import AlliancesPage from './pages/AlliancesPage';
import ContactPage from './pages/ContactPage';
import NoticiasPage from './pages/NoticiasPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/nuestros-programas" element={<ProgramsPage />} />
          <Route path="/quienes-somos" element={<QuienesSomosPage />} />
          <Route path="/colegios" element={<CollegesPage />} />
          <Route path="/alianzas" element={<AlliancesPage />} />
          <Route path="/noticias" element={<NoticiasPage />} />
          <Route path="/contacto" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
